import * as _ from 'lodash'
import {
  SegmentGATrack,
  SegmentElement,
  SegmentPage,
  SegmentTrack,
} from '@enums/segment'
import { SUBMISSION_ERR } from '@enums/form-submission-error'
import { checkSegmentId } from '@util/check-segment-id'

/**
 * click tracking contract with Data Science
 */
export type TrackClickProperties = {
  page: SegmentPage
  element: SegmentElement
}

/**
 * API tracking contract with Data Science
 */
export type TrackApiProperties = {
  success: boolean
  reason?: SUBMISSION_ERR
}

/**
 * route-change contract with Data Science
 */
export type TrackRouteChangeProperties = {
  name: SegmentPage
}

export type TrackDataProperties = {
  page_name?: SegmentPage,
  screen_name?: SegmentPage
  forced?: boolean,
}

/**
 * contract with Marketing (Google Analytics click track)
 */
export type GATrackProperties = {
  // TODO: break this out into enums if necessary — right now Marketing needs
  // a single click event tracked
  category: string
  action: string
  label: string
  requester: 'marketing'
}

/**
 * tracking contract with Data Science
 */
export type SegmentTrackMethod = {
  /**
   * event: a click or API call string
   * properties: additional details regarding the item being tracked
   */
  (
    event: SegmentTrack | SegmentGATrack,
    properties:
      | TrackClickProperties
      | TrackApiProperties
      | TrackRouteChangeProperties
      | TrackDataProperties
      | GATrackProperties
  ): void
}

/**
 * abstraction around Segment's track method
 * Segment spec: https://segment.com/docs/connections/spec/track/
 *
 * Thrive spec for this call: https://thrive-global.atlassian.net/wiki/spaces/DG/pages/331186177/Web+Sign+Up#Track
 */
export const segmentTrack: SegmentTrackMethod = (event, properties) => {
  const analytics = window.analytics
  analytics?.ready(() => {
    checkSegmentId()
    analytics.track(event, _.assign(properties, { web_app: 'web' }))
  })
}
